import { useMediaQuery } from "@react-hookz/web";
import screens from "../../config/screensConfig";

export const useIsDesktop = () =>
  useMediaQuery(`(min-width: ${screens.dsk})`, {
    initializeWithValue: true,
  }) as boolean;
